import React from "react";
import { Check, Sparkles } from "lucide-react";
import { Reveal, MaskReveal } from "./Reveal";

const INCLUDED = [
  "Unlimited document uploads",
  "AI review, categorization & plain-English explanations",
  "Automated deadline & renewal monitoring",
  "Paperwork preparation assistance",
  "Compliance reasoning with source attribution",
  "Ask DOX — unlimited questions",
  "Business profile memory",
  "Priority email support",
];

export default function Pricing({ onTrial }) {
  return (
    <section id="pricing" className="relative py-28 sm:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16 sm:mb-20">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-dox-orange mb-5">Pricing</div>
          <h2 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.02]">
            <MaskReveal>One plan.</MaskReveal>
            &nbsp;
            <MaskReveal delay={0.15}><span className="text-gradient-brand">Everything included.</span></MaskReveal>
          </h2>
          <Reveal delay={0.35}><p className="mt-6 text-white/60 text-lg">Hire your AI Compliance Employee for less than a single billable hour.</p></Reveal>
        </div>

        <Reveal>
          <div className="relative mx-auto max-w-lg">
            <div className="absolute -inset-6 bg-gradient-to-r from-dox-orange/25 via-dox-magenta/25 to-dox-purple/25 blur-3xl rounded-[2rem]" />
            <div className="relative glass-strong rounded-3xl border border-white/15 p-8 sm:p-10">
              <div className="flex items-center gap-2 mb-6">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-dox-orange/15 text-dox-orange px-3 py-1 text-xs font-bold">
                  <Sparkles size={12} /> Full Access
                </span>
              </div>
              <div className="flex items-end gap-2">
                <span className="font-display font-black text-6xl text-white">$99</span>
                <span className="text-white/50 mb-2">/ month</span>
              </div>
              <p className="mt-2 text-sm text-white/50">14-day free trial. No credit card required.</p>

              <button
                data-testid="pricing-trial-btn"
                onClick={onTrial}
                className="mt-8 w-full rounded-full bg-dox-orange py-4 min-h-[52px] font-bold text-white shadow-[0_0_36px_rgba(30,120,255,0.5)] hover:bg-dox-orangeHover hover:scale-[1.02] active:scale-95 transition-all"
              >
                Start Your 14-Day Free Trial
              </button>

              <div className="mt-8 h-px bg-white/10" />
              <ul className="mt-8 space-y-3.5">
                {INCLUDED.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-gradient-to-br from-dox-orange to-dox-magenta text-white shrink-0">
                      <Check size={12} />
                    </span>
                    <span className="text-sm text-white/75">{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
